import React from 'react'
import Layout from '../components/Layout'
import NavDashboard from '../components/NavDashboard'
import AdminDashboard from '../components/AdminDashboard'

const ADashboard = () => {
  return (
    <div>
        <Layout/>
        <NavDashboard/>
        <AdminDashboard/>
    </div>
  )
}

export default ADashboard